export const PAGES = {
  SELECT_EVENT: "selectEvent",
  SELECT_CONTENT: "selectContent",
  CONFIRMATION: "confirmation"
};

export const NAMESPACE = "CloneModuleModal";
